import { pxToRem } from '../../../../utils';
export var listItemMediaStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    return Object.assign({}, p.important && {
      '::before': {
        content: '""',
        position: 'absolute',
        left: pxToRem(8),
        width: pxToRem(2),
        height: pxToRem(2),
        background: '#000'
      }
    }, (p.hasHeader || p.hasContent) && {
      marginRight: v.gap
    });
  }
};